<mat-form-field appearance="outline" class="no-padding">
  <mat-label *ngIf="label">{{label}}</mat-label>
  <mat-chip-grid #chipList>
    <mat-chip-row
      *ngFor="let user of selectedItems;let indx=index;"
      (removed)="remove(indx)">
      {{user.label}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      [placeholder]="placeholder"
      #itemInput
      [formControl]="itemsCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    >
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let item of filteredItems$ | async" [value]="item">
      {{item.label}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
